export const MAP_SIZE = 12;
